// CSS
import "./styles/global.scss";

// JS
import $ from "jquery";

window.jQuery = window.$ = $;
require("jquery-validation");
require("datatables.net");
require("prismjs");
import Bloodhound from 'corejs-typeahead/dist/bloodhound.js';
window.Bloodhound = Bloodhound;
require('corejs-typeahead/dist/typeahead.jquery.js');
require('./externals/funnelback.autocompletion-2.6.0.js');

import "/node_modules/@qhealth-design-system/core/src/components/_global/js/global.js";

import "./components/_global/js/user_location/global.js";
import "/node_modules/@qhealth-design-system/core/src/components/_global/js/tabs/global.js";
import "/node_modules/@qhealth-design-system/core/src/components/_global/js/modal/global.js";
import "./components/_global/js/forms/global.js";
import "/node_modules/@qhealth-design-system/core/src/components/_global/js/animate/global.js";
import "/node_modules/@qhealth-design-system/core/src/components/_global/js/_polyfills/global.js";
import "/node_modules/@qhealth-design-system/core/src/components/_global/js/toggle_and_tool_tip/global.js";
import "/node_modules/@qhealth-design-system/core/src/components/_global/js/select_boxes/global.js";
import "/node_modules/@qhealth-design-system/core/src/components/_global/js/cta_links/global.js";

import "/node_modules/@qhealth-design-system/core/src/components/accordion/js/global.js";
import "/node_modules/@qhealth-design-system/core/src/components/global_alert/js/global.js";
import "/node_modules/@qhealth-design-system/core/src/components/basic_search/js/global.js";
import "/node_modules/@qhealth-design-system/core/src/components/in_page_navigation/js/global.js";
import "/node_modules/@qhealth-design-system/core/src/components/internal_navigation/js/global.js";
import "/node_modules/@qhealth-design-system/core/src/components/main_navigation/js/global.js";
import "/node_modules/@qhealth-design-system/core/src/components/mega_main_navigation/js/global.js";
import "/node_modules/@qhealth-design-system/core/src/components/code/js/global.js";
import "/node_modules/@qhealth-design-system/core/src/components/tab/js/global.js";
import "/node_modules/@qhealth-design-system/core/src/components/toggle_tip/js/global.js";
import "/node_modules/@qhealth-design-system/core/src/components/tool_tip/js/global.js";
import "/node_modules/@qhealth-design-system/core/src/components/a-z_listing/js/global.js";
import "/node_modules/@qhealth-design-system/core/src/components/loading_spinner/js/global.js";
import "/node_modules/@qhealth-design-system/core/src/components/file_upload/js/global.js";
import "/node_modules/@qhealth-design-system/core/src/components/promo_panel/js/global.js";
import "/node_modules/@qhealth-design-system/core/src/components/overflow_menu/js/global.js";
import "/node_modules/@qhealth-design-system/core/src/components/breadcrumbs/js/global.js";
import "/node_modules/@qhealth-design-system/core/src/components/video_player/js/global.js";
import initHeader from "/node_modules/@qhealth-design-system/core/src/components/header/js/global.js";
import initLeftHandNav from "/node_modules/@qhealth-design-system/core/src/components/left_hand_navigation/js/global.js";

// Adding ES module initialisation for components
document.addEventListener("DOMContentLoaded", () => {
    initHeader(document);
    initLeftHandNav(document);
    setTimeout(function() {
        window.QLD = window.QLD || {};
        window.QLD._coreReady = true;
        window.dispatchEvent(new CustomEvent('qld:main:ready'));
    }, 0);
});